import { OnInit, Component, Input } from '@angular/core';

@Component({
    selector: 'app-seriados-reimpresiones',
    templateUrl: './seriados.component.html'
})
export class SeriadosConsumoComponent implements OnInit {

  private readonly _DEFAULT_ITEMS_PER_PAGE = 5;
  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 1;
  public totalItems: number;
  public readonly visiblePages = 3;
  public firstItemList = 0;
  public lastItemList = this.itemsPerPage;

  @Input() seriados;

  ngOnInit() {
    this.totalItems = this.seriados.length;
  }

  public pageChange(page) {
    this.currentPage = page;
    this.firstItemList = this.itemsPerPage * (page - 1);
    this.lastItemList = this.itemsPerPage * page;
  }

}
